import React from 'react';
import { Text } from 'rebass/styled-components';
import styled from 'styled-components';
import Collapsible from 'react-collapsible';
import { isIOS } from 'react-device-detect';

import chevronDown from '../../assets/images/chevron-down.svg';

const Container = styled.div`
  .Collapsible {
    border: 2px solid #e1e1e1;
    border-radius: 9px;
    padding: 10px;
    margin: 8px 0px;
  }

  .Collapsible__contentInner {
    padding: 10px;
  }

  .Collapsible__trigger {
    display: block;
    text-decoration: none;
    position: relative;
    padding: 10px;
    padding-right: 34px;
    cursor: pointer;
  }

  .Collapsible__trigger:after {
    content: url(${chevronDown});
    position: absolute;
    right: 10px;
    top: 10px;
    display: block;
    transition: transform 300ms;
  }

  .Collapsible__trigger.is-open:after {
    transform: rotateZ(180deg);
  }
`;

const Collapse = ({ question, answer }) => (
  <Container>
    <Collapsible
      trigger={
        <Text fontSize={2} fontWeight="600">
          {question}
        </Text>
      }
      transitionTime={300}
      open={isIOS}
    >
      <Text fontSize={1} fontFamily="lato">
        {answer}
      </Text>
    </Collapsible>
  </Container>
);

export default Collapse;
